import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import Box from '@mui/material/Box';
import moment from 'moment';

// Icons 

import MoreVertIcon from '@mui/icons-material/MoreVert';
import getStatusColor from '../../../../util/style/getStatusColor';
import { getGroupMemberInfo } from '../../../../routes/doctor/account';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';
import { useTranslation } from 'react-i18next';

type Props = {
  item: any; 
};


const MemberRow: React.FC<Props> = ({ item }) => {

  const { t } = useTranslation(); 

  const colors = useAppSelector(state => state.theme.colors); 
  const accountInfo = useAppSelector(state => state.meta.accountInfo); 

  const groupAccess = useAppSelector(state => state.group.groupAccess); 

  const [account, setAccount] = useState(null) as any; 
  const [status, setStatus] = useState(''); 

  // -- 

  const handleGroupMemberInfo = async () => { 

    const res = await getGroupMemberInfo(item._id) as any; 

    if (res.data.status === 200) { 

      setAccount(res.data.doctor); 

      if (res.data.isMainDoctorId) { 

        setStatus('admin'); 

      }; 

    }; 

  }; 

  // -- 

  useEffect(() => { 

    if (item) { 

      handleGroupMemberInfo(); 

      setStatus(item?.status); 

    }; 

  },[item]); 

  // -- 

  return (

    <Box 
      sx={{ 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center', 
      width: '100%',
      fontSize: 12, 
      height: 50,
      '&:hover': { backgroundColor: colors?.sectionHover, cursor: 'default' }
    }}>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row',
                alignItems: 'center',
                width: '77%',
                marginLeft: '3%',  
                textAlign: 'left',
                overflow: 'hidden',
            }}>{account?.firstName} {account?.lastName}</div>

            <div style={{ 
                width: '18%', 
                textAlign: 'right',
                overflow: 'hidden',
                marginRight: '2%'
            }}>
                <strong style={{ 
                    padding: 5,
                    borderRadius: 7,
                    backgroundColor: getStatusColor(status), 
                    color: 'white', 
                }}>
                    {t(status)}
                </strong>
            </div>
            
    </Box>

  );

};

export default MemberRow;